import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';

const ApprovalList = ({ approvals, onApprove, onReject, maxItems = 8, onShowMore, accent }) => {
  if (!approvals || approvals.length === 0) return null;

  return (
    <>
      {approvals.slice(0, maxItems).map(a => (
        <Paper
          key={`${a.type}-${a.id}`}
          variant="outlined"
          sx={{
            p: 1.5, mb: 0.75, borderRadius: 1,
            borderColor: accent ? `${accent}33` : 'divider',
            bgcolor: accent ? `${accent}08` : 'transparent',
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" fontWeight={600} noWrap>{a.title}</Typography>
            <Typography variant="caption" color="text.secondary">
              {a.child_name || a.childName} — {a.type === 'task' ? 'Tehtävä' : a.type === 'shared_goal' ? 'Yhteinen tavoite' : 'Ostos'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            <Button size="small" variant="contained" color="success" onClick={() => onApprove(a)} startIcon={<CheckIcon sx={{ fontSize: 16 }} />} sx={{ flex: 1, textTransform: 'none', fontWeight: 600, borderRadius: 1, py: 0.25 }}>
              {a.type === 'shared_goal' ? 'Palkitse' : 'Hyväksy'}
            </Button>
            <Button size="small" variant="outlined" color="error" onClick={() => onReject(a)} startIcon={<CloseIcon sx={{ fontSize: 16 }} />} sx={{ flex: 1, textTransform: 'none', fontWeight: 600, borderRadius: 1, py: 0.25 }}>
              {a.type === 'shared_goal' ? 'Ohita' : 'Hylkää'}
            </Button>
          </Box>
        </Paper>
      ))}
      {approvals.length > maxItems && onShowMore && (
        <Typography
          variant="caption"
          color="primary"
          sx={{ px: 0.5, cursor: 'pointer' }}
          onClick={onShowMore}
        >
          +{approvals.length - maxItems} lisää...
        </Typography>
      )}
    </>
  );
};

export default React.memo(ApprovalList);
